import React from "react";

import MyCountdown from "../parts/countdown";
import Form from "../forms/form";
import {IoCalendar} from "react-icons/io5";
import {MdPlace} from "react-icons/md";
import DOMPurify from "dompurify";
import FirstScreenSpeacers from "../parts/firsrtscreen-speacers";

import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import LogoBWS from "../../img/bws-logo.svg";
import BWSVideo from "../../img/video/bws_video.mp4"

import SiteDecor from "../../img/site-decor.webp"


function FirstScreenSlider({fsData}) {
    return (
        fsData ?
            <section className="relative py-24 lg:pt-32 overflow-hidden" id="top">
                <div>
                    <video className="absolute top-0 left-0 w-full h-full -z-10 object-cover" loop autoPlay playsInline muted>
                        <source src={BWSVideo} type="video/mp4"/>
                    </video>
                    <div className="absolute inset-0 -z-10 bg-[linear-gradient(0deg,#ece66a_0%,rgba(24,170,126,0.65)_33.65%,rgba(233,247,242,0.95)_100%)]"></div>
                </div>

                <div className="container  relative max-w-screen-xl mx-auto px-[15px]">

                    <div className="grid w-full grid-cols-1 md:grid-cols-2  md:items-end lg:items-center lg:grid-cols-[55%,45%]">

                        <div className="flex flex-col items-center md:items-start ">
                            
                            <div className="flex items-end gap-4 md:flex-col md:items-start lg:gap-8 mb-10 xl:mb-12">
                                <a href="/" className="block w-full  max-w-[150px] lg:max-w-[360px]"><img src={LogoBWS} alt="Logo BWS"/></a>

                                <div className="flex flex-col md:flex-row justify-center gap-2 md:gap-4 lg:items-start">
                                    <div className="flex items-center gap-[10px] bg-black text-white py-1 pr-5 pl-3 lg:pr-4 lg:pl-3">
                                        <MdPlace className="text-[20px] md:text-[30px]"/>
                                        <span className="text-base md:text-lg lg:text-2xl">Київ</span>
                                    </div>
                                    {/*<div  className="flex items-center gap-[10px] bg-black text-white py-1 pr-5 pl-3 lg:pr-4 lg:pl-3">
                                        <IoCalendar className="text-[20px] md:text-[30px]"/>
                                        <span className="text-base md:text-lg lg:text-2xl">15/04/2026</span>
                                    </div>*/}
                                </div>
                            </div>

                            <div className="relative z-10 w-full max-w-[510px] bg-white  px-5 py-6 md:px-8 ">
                                {/*<div className="sm:w-[300px] w-full"> 
                                    <div className="flex items-center gap-6 mb-4 md:mb-5">
                                        <p className="text-3xl bg-black text-white py-1 pr-5 pl-3 lg:pr-4 lg:pl-3">Івент закінчився</p>
                                        <div>
                                            <div className="flex items-end gap-[6px] leading-none py-1 px-3 bg-[#009064] font-bold text-white mb-3">
                                                <span className="text-3xl">5000</span>
                                                <span className="text-[15px]">грн*</span>
                                            </div>
                                            <p className="text-xs font-light">* Ціна до оподаткування</p>
                                        </div>
                                         <div>
                                            <div className="flex items-center gap-[6px] font-bold">
                                                <span className="relative text-3xl">5000
                                                    <span className="block absolute -left-[8px] top-1/2 -translate-y-1/2
                                                        w-[120%] h-[3px] bg-[#b43125] opacity-80 -rotate-6"></span>
                                                </span>
                                                <span className="text-[15px]">грн*</span>
                                            </div>
                                            <p className="text-xs font-light">* Ціна до оподаткування</p>
                                        </div> 
                                    </div>

                                    <div className="mb-5 md:mb-7 lg:mb-0">
                                        <MyCountdown/>
                                    </div>
                                </div>*/}

                                <Form/>
                            </div>

                        </div>

                        {/*<div class="sm:mb-0 mb-10 relative z-20">
                            <div
                                class="bg-[linear-gradient(280deg,#009064_15.38%,#3ac097_61.93%,#ece66a_100%)] pt-4 px-4  pb-8 text-white overflow-hidden">
                                <iframe class="w-full h-[300px] "
                                    src="https://www.youtube.com/embed/LHHY08jbV4g?si=amM_RJxGhwlQfeJA" title="YouTube video player"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen=""></iframe></div>
                        </div>*/}
                        
                        
                        {/*<FirstScreenSpeacers slider_data={fsData.fs_speacers_slider}/>*/}

                        {/*<div className="absolute top-3/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full 
                            md:w-1/2 md:left-3/4 xl:w-[70%] xl:-right-[12%]">
                            <img src={SiteDecor} alt="decor" className="w-full"/>
                        </div>*/}
                    </div>

                </div>
                
            </section>
        : ''
    )
}

export default FirstScreenSlider